import { render, staticRenderFns } from "./categorySeoContent.vue?vue&type=template&id=5dc054fd&scoped=true"
import script from "./categorySeoContent.vue?vue&type=script&lang=js"
export * from "./categorySeoContent.vue?vue&type=script&lang=js"
import style0 from "./categorySeoContent.vue?vue&type=style&index=0&id=5dc054fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc054fd",
  null
  
)

export default component.exports